import React, { useState } from "react";
import "./booknow.css";

export default function BookNow() {

  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      fullName,
      phone,
      quantity,
      email
    };

   await fetch("https://script.google.com/macros/s/AKfycbxN1KZ7pjrC4LkfW_0OwSIN6Dvb9CukPv5sXCVvMWNtqnzw7Hn7fnqkwJcYOdbfyM1P/exec", {
  method: "POST",
  mode: "no-cors",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify(data),
});


    setSubmitted(true);
  };

  return (
    <div className="book-root">

      <div className="form-card">

        {!submitted ? (
          <>
            <h2 className="form-title">Contact Us</h2>

            <form onSubmit={handleSubmit} className="lead-form">

              <input
                type="text"
                placeholder="Full Name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />

              <input
                type="tel"
                placeholder="Contact Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />

              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <button type="submit" className="submit-btn">
                Submit
              </button>

            </form>
          </>
        ) : (
          <div className="thankyou-box">
            <h2>🎉 Thank You!</h2>
            <p>Your booking request has been received.</p>
            <p>We will contact you shortly.</p>
          </div>
        )}

      </div>

    </div>
  );
}
